import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromAuth from '../../../../../store/auth';
import * as fromUi from '../../../../../store/ui';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { startWith, map, withLatestFrom, tap } from 'rxjs/operators';
import { IDataScope } from 'src/app/modules/auth/models/IDataScope';
import { MatOption } from '@angular/material/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-location-picker',
    templateUrl: './location-picker.component.html',
    styleUrls: ['./location-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LocationPickerComponent implements OnInit, OnDestroy {
  @Output() picked = new EventEmitter<IDataScope>();

  shouldFilter$ = new BehaviorSubject<boolean>(false);

  control = new UntypedFormControl('');

  locations$ = this.store.select(fromAuth.selectAvailableLocations).pipe(
    map(loc =>
      loc.slice().sort((a, b) => {
        if (a.customer > b.customer) return 1;
        if (a.customer < b.customer) return -1;
        return a.name > b.name ? 1 : -1;
      }),
    ),
  );
  selectedLocation$ = this.store.select(fromUi.selectSelectedLocationId).pipe(
    tap(locationId => {
      if (locationId === null) {
        this.control.setValue(null, {
          emitEvent: false,
        });
      }
    }),
    withLatestFrom(this.locations$),
    map(([locationId, locations]) => locations.find(loc => loc.id === locationId)),
  );

  filteredLocations$ = combineLatest([this.locations$, this.control.valueChanges.pipe(startWith('')), this.shouldFilter$]).pipe(
    map(([locations, value, shouldFilter]) => {
      if (!shouldFilter) return locations;

      let term = '';
      if (typeof value === 'string') {
        term = value;
      } else {
        term = (value as IDataScope) ? value.name : '';
      }

      return locations.filter(
        loc => loc.name.toLowerCase().includes(term.toLowerCase()) || loc.customer.toLowerCase().includes(term.toLowerCase()),
      );
    }),
  );

  constructor(private store: Store<{ auth: fromAuth.AuthState }>) {}

  ngOnInit() {
    this.selectedLocation$.pipe(untilDestroyed(this)).subscribe(location => {
      if (location) {
        this.control.setValue(location);
      }
    });
  }

  ngOnDestroy() {}

  displayOption(option: IDataScope) {
    return option ? option.name : '';
  }

  selectLocation(option: MatOption) {
    this.picked.emit(option.value);
    this.shouldFilter$.next(false);
  }
}
